import {defaultActionCreator} from "./actionCreator";

export const GET_INSTRUMENTS_PARTNER_REQUEST = 'GET_INSTRUMENTS_PARTNER_REQUEST'
export const getInstrumentsPartnerRequest = defaultActionCreator(GET_INSTRUMENTS_PARTNER_REQUEST, 'data')
export const GET_INSTRUMENTS_PARTNER_SUCCESS = 'GET_INSTRUMENTS_PARTNER_SUCCESS'
export const getInstrumentsPartnerSuccess = defaultActionCreator(GET_INSTRUMENTS_PARTNER_SUCCESS, 'data')
export const GET_INSTRUMENTS_PARTNER_FAILED = 'GET_INSTRUMENTS_PARTNER_FAILED'
export const getInstrumentsPartnerFailed = defaultActionCreator(GET_INSTRUMENTS_PARTNER_FAILED, 'data')